import { Controller } from "@hotwired/stimulus"

// Client-only visibility toggle. Used to show/hide inline reply forms
// beneath a comment. Focuses the first textarea when revealed.
export default class extends Controller {
  static get targets() {
    return ["content"]
  }

  toggle() {
    this.contentTarget.hidden = !this.contentTarget.hidden

    if (!this.contentTarget.hidden) {
      const textarea = this.contentTarget.querySelector("textarea")
      if (textarea) {
        textarea.focus()
      }
    }
  }
}
